import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserService} from '../../../../services/user.service';
import {InfluencerService} from '../../../../services/influencer/influencer.service';
import {StringUtils} from '../../../../utils/string.utils';
import {CacheService} from '../../../../services/cache/cache.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'platform-select',
  templateUrl: './platform-select.component.html',
  styleUrls: ['./platform-select.component.scss']
})
export class PlatformSelectComponent implements OnInit  {
  @Input() influencerId: number;
  @Input() showSelectedChannel = false;
  @Output() changePlatformEvent: EventEmitter<any> = new EventEmitter<any>();
  public platformsOption: any[] = [];
  public platforms: string;
  public activeChannelId;
  public activeChannelName: string;
  private currentInfluencer;
  constructor(private userService: UserService,
              private influencerService: InfluencerService,
              private translate: TranslateService) {
  }
  ngOnInit() {
    this.currentInfluencer = this.userService.getInfluencerInfo();
    if (this.currentInfluencer) {
      this.fetchListChannel(this.currentInfluencer.id);
    } else if (this.influencerId) {
      this.fetchListChannel(this.influencerId);
    }
  }
  fetchListChannel(influencerId) {
    this.influencerService.fetchListChannel(influencerId)
      .subscribe((res) => {
        this.platformsOption = [{
          id: 0,
          name: this.translate.instant('channel_specific.placeholder'),
          platformName: ''
        }, ...res];
        if (this.platformsOption.length > 0) {
          const currentActiveChannel = this.influencerService.currentActiveChannel;
          let selectedChannel;
          if (currentActiveChannel) {
            selectedChannel = this.platformsOption.find(p => p.id === currentActiveChannel.id);
          }
          if (!selectedChannel) {
            selectedChannel = this.platformsOption[0];
          }
          this.activeChannelId = selectedChannel.id;
          this.activeChannelName = selectedChannel.platformName.toLowerCase();
          this.changePlatformEvent.emit(selectedChannel);
        }
    });
  }

  onChangePlatform(evt) {
    if (evt) {
      this.changePlatformEvent.emit(evt);
      this.activeChannelName = evt.platformName.toLowerCase();
    }
  }

  capitalizePlatformName(platformName) {
    return StringUtils.capitalize(platformName);
  }

  get channelContent() {
    if (!this.activeChannelName || this.activeChannelName === '') {
      return this.translate.instant('profile.show_all');
    }
    const selectedChannel = this.platformsOption.find(p => p.id === this.activeChannelId);
    if (!selectedChannel) {
      return null;
    }
    return this.showSelectedChannel ? selectedChannel.handle : `${this.translate.instant('profile.show')} ${selectedChannel.handle}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-overview-tab/platform-select/platform-select.component.ts